const JsonToTable = ({
  data,
  excludeKeys = ["id", "type", "classification", "growthStageScale"],
  tableClassName = "table table-bordered table-sm bg-dark",
  cellClassName = "p-1",
  headerCellClassName = "fw-bold bg-light p-1",
  maxHeight = "300px",
  maxWidth = "1000px",
  defLang,
}) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="text-muted small">No data available</div>;
  }

  const renderCell = (value) => {
    if (value === null || value === undefined) return "-";

    if (Array.isArray(value)) {
      if (value.length === 0) return "-";

      if (typeof value[0] === "object" && value[0] !== null) {
        return (
          <JsonToTable
            defLang={defLang}
            data={value}
            excludeKeys={excludeKeys}
            maxHeight="none"
            maxWidth="none"
          />
        );
      } else {
        return value.join(", ");
      }
    }

    if (typeof value === "object") {
      const filtered = Object.fromEntries(
        Object.entries(value).filter(([key]) => !excludeKeys.includes(key))
      );
      return (
        <JsonToTable
          defLang={defLang}
          data={[filtered]}
          excludeKeys={excludeKeys}
          maxHeight="none"
          maxWidth="none"
        />
      );
    }

    return String(value);
  };

  return (
    <div
      className="table-responsive"
      style={{ maxHeight, maxWidth, overflow: "auto", fontSize: "11px" }}
    >
      <table className={`${tableClassName} w-100`}>
        <tbody>
          {data.map((row, rowIndex) => {
            const hasNoneKey = Object.keys(row).some((key) =>
              key.includes("@none")
            );

            return Object.keys(row)
              .filter((key) => !excludeKeys.includes(key))
              .filter((key) => {
                if (hasNoneKey) {
                  return key === defLang || key === "en" || key === "@none";
                }
                return true;
              })
              .map((key) => (
                <tr key={`${rowIndex}-${key}`}>
                  <th className={headerCellClassName} style={{ textAlign: "left" }}>
                    {key}
                  </th>
                  <td className={cellClassName}>{renderCell(row[key])}</td>
                </tr>
              ));
          })}
        </tbody>
      </table>
    </div>
  );
};

export default JsonToTable;
